import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = {
  xmlns: "http://www.w3.org/2000/svg",
  width: "16",
  height: "16",
  fill: "none",
  viewBox: "0 0 16 16"
}

export function render(_ctx, _cache) {
  return (_openBlock(), _createElementBlock("svg", _hoisted_1, _cache[0] || (_cache[0] = [
    _createElementVNode("path", {
      stroke: "currentColor",
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "1.5",
      d: "M13.277 6.8H2m11.277 0v-.72c0-1.008 0-1.512-.201-1.897a1.82 1.82 0 0 0-.807-.787c-.394-.196-1.034-.196-2.068-.196m3.076 3.6v.9M2 6.8v4.32c0 1.008 0 1.512.201 1.897.177.339.46.614.807.787.394.196.911.196 1.945.196h2.89M2 6.8v-.72c0-1.008 0-1.512.201-1.897.177-.339.46-.614.807-.787.394-.196.911-.196 1.945-.196h.123m0 0H10.2m-5.125 0V2m0 1.2v1.2M10.2 3.2V2m0 1.2-.003 1.2M14 11.12s-.248-.685-.723-1.12-1.025-.8-1.888-.8c-1.449 0-2.623 1.075-2.623 2.4 0 1.326 1.174 2.4 2.623 2.4.94 0 1.683-.71 1.888-1M14 11.12v-1.6m0 1.6h-1.748"
    }, null, -1)
  ])))
}
export default { render: render }